import './App.css'; // Import global styles

// Importing components
import Portfolio from './components/layout/Portfolio';

export default function App() {
  return (
    <Portfolio />
  );
}
